import React, { useContext } from 'react';
import {Authcontext} from "../context/Authcontext";
import {Route, Redirect } from "react-router-dom";

function PrivateRoute({component: Component, ...rest}) {
    const {User} = useContext(Authcontext);
    return (
        <Route {...rest} component={(props)=>
            User!=null ? (
                <Component {...props} />
            ): (<Redirect to="/" />
)        } />
    )
}

export default PrivateRoute
